<template>
  <div class="web-nav">
    <div class="nav-box">
      <div class="web-logo-box"></div>
      <div class="navs">
        <div v-for="(nav, i) in navs" :key="navs.path" :index="i+1+''"  class="nav" :class="{active: active(nav)}"
             @click="toPath(nav)">
          
          <div>
            {{nav.name}}
            <span v-if="badgeData[nav.path]" class="badge-dot"></span>
          </div>
          <div class="after"></div>
        </div>
      </div>
      <div class="nav-user">
        <div class="user-content" v-if="customerName">
          <el-tooltip effect="dark">
              <div slot="content">{{customerName}}</div>
               <img :src="userIcon" height="14" style="margin-right: 5px" width="14"/>
          </el-tooltip>
          {{customerNameSubstring}}
          <span @click="logoutHandler" style="color: #4C7eC5;cursor: pointer" v-track-click="{eventId: 'logout', title: '退出登录'}">&nbsp;[&nbsp;退出&nbsp;]</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import userIcon from '../assets/user.svg'
  import {logout} from "../service/login";
  import {myApplyCount} from "../service/user"

  export default {
    props: {
      customer_name: {
        type: String
      }
    },
    data() {
      return {
        activeIndex: '1',
        customerType: '1',
        navs: [
          {path: '/myPropertiesTab', name: '我的资产'},
          {path: '/on-passage-application', name: '我的预约'},
          {path: '/myAttentionTab', name: '产品信息'},
          {path: '/historyTab', name: '交易记录'},
          {path: '/noticeHistoryList', name: '公告'},
          {path: '/reportHistoryList', name: '报告'},
          {path: '/productInformationHistoryList', name: '产品资讯'},
          {path: '/personalData', name: '个人中心'}
        ],
        childrenNavs: {
          '/myAttentionTab': ['/purchase']
        },
        userIcon: userIcon
      }
    },
    mounted() {
      // //  根据登录投资者类型展示个人资料
      // this.customerType = localStorage.getItem("customerType")
      // switch (this.customerType) {
      //   case "0":
      //   // this.navs.push({path: '/personalData', name: '机构资料'});
      //   // break
      //   case "1":
      //   // this.navs.push({path: '/personalData', name: '个人资料'});
      //   // break
      //   case "5":
      //     this.navs.push({path: '/personalData', name: '个人中心'});
      //     break
      // }
      this.navs.some((item, i) => this.chooseActiveNav(item, i))
    },
    computed: {
      badgeData() {
        return {
          // 个人中心
          ['/personalData']: this.$store.state.base.isIdCardExpired,
        }
      },
      fullPath() {
        return this.$route.fullPath
      },
      customerName() {
        return this.$store.state.base.customerName
      },
      customerNameSubstring() {
         let customerName = this.$store.state.base.customerName
         if (customerName.length > 5) {
           customerName = customerName.substring(0,7)+'...'
         }
        return customerName
      },
    },
    methods: {
      async logoutHandler() {
        this.$store.commit("clearUser")
        await logout()
        localStorage.removeItem('insertClientId')
        this.$router.replace({path: '/login'})
      },
      async toPath(nav){
        if(this.$route.fullPath === nav.path){
          return
        }
        console.log('nav.path', nav.path)
        if ("/on-passage-application" === nav.path){
          let res = await myApplyCount({})
          if (res.data.appoint_count <= 0){
            this.$router.push('/history-application')
            return
          }
        }
        this.$router.push(nav.path)
      },
      handleSelect(a, b) {
        console.log(a, b)
      },
      chooseActiveNav(item, i) {
        // 先找当前路径是否包含菜单路径
        let fullPath = this.$route.fullPath
        if (fullPath.indexOf(item.path) > -1) {
          this.activeIndex = ++i + ''
          return true
        }
        // 再找当前路径时否包含菜单的子路径
        let childNavs = this.childrenNavs[item.path]
        if (!childNavs) {
          return false
        }
        for (let j in childNavs) {
          let childNav = childNavs[j]
          if (fullPath.indexOf(childNav) > -1) {
            console.log(childNav)
            this.activeIndex = ++i + ''
            return true
          }
        }
      },
      active(nav) {
        return this.$route.path === nav.path ||
          (this.$route.meta.parentTitle && this.$route.meta.parentTitle[0].path === nav.path)
      }
    },
    watch: {
      fullPath() {
        this.navs.some((item, i) => this.chooseActiveNav(item, i))
      }
    }
  }
</script>

<style lang="less" scoped>
  .web-nav {
    height: 88px;
    background: #FFFFFF;
    line-height: 88px;
    overflow: hidden;
    display: flex;

    .nav-box {
      width: 1100px;
      margin-left: calc(50vw - 550px);
      display: grid;
      grid-template-columns: 151px 1fr 215px;

      .web-logo-box {
        margin-top: 21px;
        height: 48px;
        width: 151px;
      }

      .navs {
        //margin-left: auto;
        display: flex;
        justify-content: space-around;

        .nav {
          font-size: 16px;
          min-width: 80px;
          cursor: pointer;
          //margin-left: 50px;
          flex-grow: 1;
          text-align: center;
          color: #333333;
          position: relative;

          .badge-dot {
            position: absolute;
            top: 30px;
            right: 8px;
            width: 8px;
            height: 8px !important;
            background: #e74c3c;
            border-radius: 50%;
          }

          .after {
            width: 46px;
            height: 2px;
            margin: 0 auto;
          }

          div:first-child {
            height: calc(100% - 4px);
          }

          &.active {
            color: #4C7EC5;

            .after {
              background: #4c7ec5;
            }
          }
        }
      }

      .nav-user {
        width: 215px;
        text-align: right;

        .user-content {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
  }
</style>
